var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71687 1.02195C7.66966 0.40803 6.32594 0.768081 5.72599 1.82336L2.49534 7.53825C2.13222 8.17697 2.34996 8.9896 2.9838 9.36119C3.61763 9.73277 4.41953 9.5179 4.78265 8.87918L6.78184 5.33038C6.90815 5.10822 6.83753 4.84466 6.61706 4.71541C6.3966 4.58617 6.13653 4.65585 6.01022 4.87802L3.98347 8.41066C3.87296 8.60506 3.61288 8.67474 3.41998 8.56165C3.22707 8.44856 3.15645 8.185 3.26696 7.99061L6.49762 2.27572C6.84495 1.66477 7.64685 1.4499 8.25313 1.80533C8.85941 2.16076 9.07715 2.9734 8.72982 3.58434L5.49916 9.29924C4.89922 10.3545 3.57717 10.7088 2.55164 10.089C1.50443 9.4751 1.14545 8.13535 1.75128 7.10204L4.65627 1.99229C4.78257 1.77013 4.71195 1.50657 4.49149 1.37732C4.27102 1.24807 4.01095 1.31776 3.88464 1.53992L0.973767 6.62771C0.137003 8.09954 0.648999 10.0103 2.10957 10.8666C3.57015 11.7229 5.4557 11.2176 6.29246 9.74579L9.529 4.05286C10.1289 2.99759 9.76407 1.63588 8.71687 1.02195Z",
    fill: "#082E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.fd5fb108686f11263b4d0eb2148b9955.svg";
export { ForwardRef as ReactComponent };